var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{attrs:{"width":"102","height":"35","src":"/img/samalight.png"}}),_vm._v("    Open Banking Functional Conformance Suite")]),_c('TheNotificationBell')],1)}
var staticRenderFns = []

export { render, staticRenderFns }